const callPhoneNumber = (number: string): any => alert("Called Phone Number: " + number)

export default callPhoneNumber
